export const supplyChainHostWarehouse =
    process.env.NODE_ENV === 'production' ? '//jxppwdr.jd.com' : '//jxppwdr-beta.jd.com'; // 供应链采购&排期接口域名，其他业务勿用该方法

// export const dutyHost =

export const getLoginType = () => {
    const hostName = window.location.hostname;

    if (['ex-pre-mark.jd.com', 'ex-mark.jd.com'].includes(hostName)) {
        //PC登录态
        return 3;
    }
    //erp登录态
    return 7;
};
